import { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as SrollLink, scroller } from "react-scroll";
import { useNavigate, useLocation } from "react-router-dom";
import logotext from "../../../../assets/logo.png";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import ApplyPopUp from "./ApplyPopUp";
import { path } from "framer-motion/client";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  const [openPopUp, setOpenPopUp] = useState(false);

  const handlePopUpClose = () => {
    setOpenPopUp(false);
  };

  const handlePopUpOpen = () => {
    setOpenPopUp(true);
  };

  const menuItems = [
    { text: "About Us", to: "about" },
    // { text: "Summer Camp", to: "summer" },
    { text: "Courses", to: "courses" },
    { text: "Facilities", to: "facilities" },
    { text: "Achievements", to: "acheivements" },
    { text: "Gallery", to: "gallary" },
    { text: "Faqs", to: "faqs" },
    { text: "Contact", to: "contact" },
  ];

  useEffect(() => {
    // Scroll to the correct section when the URL path changes
    if (location.hash) {
      const section = location.hash.replace("#", "");
      scroller.scrollTo(section, { smooth: true, duration: 500 });
    }
  }, [location]);

  const handleNavigation = (to) => {
    navigate(`#${to}`);
    scroller.scrollTo(to, { smooth: true, duration: 500 });
  };

  return (
    <Grid
      container
      sx={{
        padding: "5px 20px",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: "#fff",
        boxShadow: 5,
        "@media (max-width:600px)": { padding: "1px 10px" },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img
          src={logotext}
          alt="Logo"
          style={{ width: isMobile ? "200px" : "300px", height: "auto" }}
        />
      </Box>

      <Box
        sx={{
          gap: 1,
          display: "flex",
          "@media (max-width:600px)": { display: "none" },
        }}
      >
        <Button
          onClick={() => navigate("/")}
          sx={{
            color: "black",
            backgroundColor: "#fff",
            fontWeight: "bold",
            ":hover": { color: "#1d67ab" },
          }}
        >
          HOME
        </Button>
        {menuItems.map((item, index) => (
          <Button
            key={index}
            onClick={() => handleNavigation(item.to)}
            sx={{
              color: "black",
              backgroundColor: "#fff",
              fontWeight: "bold",
              ":hover": { color: "#1d67ab" },
            }}
          >
            {item.text}
          </Button>
        ))}
        <Button
          onClick={handlePopUpOpen}
          sx={{
            backgroundColor: "#1d67ab",
            color: "#fff",
            borderRadius: 10,
            fontWeight: "bold",
            px: 2,
            textTransform: "none",
          }}
        >
          Admission
        </Button>
        <ApplyPopUp
          open={openPopUp}
          onClose={handlePopUpClose}
          isApplyButton={true}
        />
      </Box>

      {/* Mobile Menu */}
      <Box sx={{ display: { xs: "flex", sm: "none" } }}>
        <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: "black" }}>
          <MenuIcon />
        </IconButton>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <Box sx={{ width: 250, mt: 5 }}>
            <List>
              {menuItems.map((item, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemButton
                    onClick={() => {
                      handleNavigation(item.to);
                      setDrawerOpen(false);
                    }}
                  >
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        </Drawer>
      </Box>
    </Grid>
  );
};

export default Header;
